import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query from React. Lives here because a CHART cannot be made responsive
 * with CSS alone: how many bars a card can label legibly is a data decision (seventeen columns that
 * read well at 950 px are an unreadable pile at 370 px), and that decision has to happen where the
 * series is built, not in a stylesheet.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(query).matches);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
